<template>
	<div>
		<Header :sel='3' @changePhone="changePhone" />
			<!-- * 内页banner * -->
			<div class="page-banner">
				<img src="@/assets/images/banner03.png">
				<div class="nybt">
					<h3>新闻资讯</h3>
				</div>
			</div>
			
			<!-- * 当前位置 * -->
			<div class="page-position">
				<div class="wh">
					当前位置：
					<a href="/">首页</a>
					&gt;
					<a href="javascript:void(0)" @click="goBack">集团动态</a> > {{name}}
				</div>
			</div>
			
			<!-- * 主体部分 * -->
			<div class="page-wrap">
				<div class="wh clearfix">
					<!-- * 左侧 * -->
					<div class="page-wrap-left xymob-menu-click visible-xs visible-sm">
						<div class="xymob-left-close-btn"><i class="icon-font icon-close"></i></div>
						<div class="xypg-left">
							<!-- * 分类 * -->
							<div class="xypg-left-box xypg-left-menu">
								<div class="xypg-left-title">
									<h3>新闻中心<span>News</span></h3>
								</div>
						
							</div>
			
						
						</div>
					</div>
			
					<!-- * 右侧 * -->
					<div class="page-wrap-right">
			
			
			
			
						<div class="xypg-right-content">
			
							<div>
								<!-- 新闻详细 -->
								<div class="xypg-news-detail">
									<h1 class="xypg-detail-title">{{detail.title}}</h1>
			
									<div class="xypg-detail-info-bar">
										<div class="detail-info-time"><i class="icon-font icon-shijian"></i>{{detail.createTime}}</div>
										<div class="detail-info-numbers"><i class="icon-font icon-chakan"></i>
											{{detail.hits}}次
										</div>
									</div>
			
									<div class="xypg-detail-con" v-html="detail.cmsArticleData?detail.cmsArticleData.content:''">
										
									</div>
			
									<!--分享插件-->
							
			
								
			
									
								</div>
							</div>
			
							<!-- 最近浏览 -->
					
			
						</div>
					</div>
			
					<!-- * 手机弹窗 * -->
			
				</div>
			</div>

			<Footer />



	</div>
</template>

<script>
	import Header from '@/components/header.vue'
	import Footer from '@/components/footer.vue'
	import axios from 'axios';


	import {
		articleDetail
	} from '@/api/reqFetch.js'

	export default {
		name: '',
		layout: '',
		components: {
			Footer,
			Header,
		},
		data() {
			return {
				id: '',
				detail: {},
				showPhone: false,
				pdfUrl: '',
				pdfDoc: null,
				pageNum: 1,
				pageCount: 0,
				name:''
			}
		},

		mounted() {
			this.id = this.$route.query.id
			this.name= this.$route.query.name||''
			this.getNewDetail();
		},

		methods: {
			goBack(){
				this.$router.go(-1)
			},
			

			changePhone(val) {
				this.showPhone = val
			},
			getNewDetail() {
				articleDetail({
					id: this.id
				}).then(res => {
					this.detail = res.data;
					try {
							let cmsArticleData = this.detail.cmsArticleData
						if(cmsArticleData && cmsArticleData.content){
							// 正则替换空格&nbsp;为一个div元素，
							cmsArticleData.content = cmsArticleData.content.replace(/&nbsp;&nbsp;&nbsp;&nbsp;/g, '<div class="su-space"></div>')
						}
						this.detail = {
							...this.detail,
							cmsArticleData: cmsArticleData
						}
					} catch (error) {
						console.error(error)
					}
					

				});
			},

			checkCategoryCode() {
				categorysortPage({
					pos: 'top'
				}).then(res => {
					if (this.level == 1) {
						res.data.map(item => {
							if (item.categoryCode == this.type) {
								this.selOneName = item.categoryName
								this.configList = item.children
							}
						})
					} else {
						res.data.map(item => {
							if (item.categoryCode == this.firstCategoryCode) {
								this.selOneName = item.categoryName
								this.configList = item.children
								this.configList.map(items => {
									if (items.categoryCode == this.type) {
										this.selName = items.categoryName
									}
								})
							}
						})
					}

				});
			},

		}
	}
</script>

<style scoped>
	/*内容*/
	.banner {
		/* background-image: url('../../assets/images/banner_03.png'); */
	}

</style>